import React from 'react'
import PropTypes from 'prop-types'
import CountryPageLatestReportsAndPublicationsBlockItem from './CountryPageLatestReportsAndPublicationsBlockItem'
import Link from 'components/Link'
import NoContent from 'components/NoContent'
import './CountryPageLatestReportsAndPublicationsBlock.scss'

const CountryPageLatestReportsAndPublicationsBlock = ({ heading, lang, items, previousPublicationsLink }) => 
    items && items.length > 0 ? 
        (
            <div className="country-page-latest-reports-and-publications-block">
                {heading && <h2 className="country-page-latest-reports-and-publications-block__heading">{heading}</h2>}
                <ul className="country-page-latest-reports-and-publications-block__items">
                    {items.map((item, index) => (
                        <li className="country-page-latest-reports-and-publications-block__item" key={index}>
                            <CountryPageLatestReportsAndPublicationsBlockItem {...item} publishedLabel={lang.publishedLabel} />
                        </li>
                    ))}
                </ul>
                {previousPublicationsLink && (
                    <Link
                        className="country-page-latest-reports-and-publications-block__previous-publications-link"
                        {...previousPublicationsLink}
                    />
                )}
            </div>
        ) : (
            <NoContent 
                heading={heading}
                message={lang.noContentMessage}
                link={previousPublicationsLink}
            />
        )

CountryPageLatestReportsAndPublicationsBlock.propTypes = {
    heading: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.exact(CountryPageLatestReportsAndPublicationsBlockItem.propTypes)),
    lang: PropTypes.shape({
        publishedLabel: PropTypes.string.isRequired,
        noContentMessage: PropTypes.string.isRequired
    }).isRequired,
    previousPublicationsLink: PropTypes.exact(Link.propTypes)

}

export default CountryPageLatestReportsAndPublicationsBlock
